<template>
    <div class="page bgF6F6F6">

        <div style="height: 46px; line-height: 46px;">
            <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="floatL font14r" @click="back();">取消</span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                            <span style="color: #F4950E;" @click="ok()">确定</span>
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body" style="margin-top: 6px;">
            <div class="paddingH4 white_bg" style=" padding-bottom: 130px;">

                <div class="paddingH4 colorBDBDBD paddingT20">
                    更换手机号后，下次登录后师讯平台绑定的手机号即为新的手机号，当前手机号为：{{dataItem ? dataItem.phone : ''}}
                </div>
                <div class="paddingH16 marginT20">
                    <div class="greyRadiusBorder height40 relative">
                        <i class="icon phoneIcon absolutePosition" style="left: 21px; top: 12px; width: 12px; height: 16px;"></i>
                        <input type="text" class="w100p borderBoxSize noBg noBorder noOutline"
                               style="padding-left: 80px; " v-model="dataItem.phone" placeholder="输入手机号"/>
                    </div>
                    <div class="marginT20 flexLayout">
                        <div class="flexItem height40 greyRadiusBorder relative">
                            <i class="icon smsIcon absolutePosition" style="left: 20px; top: 14px; width: 16px; height: 12px;"></i>
                            <input type="text" class="w100p borderBoxSize noBg noBorder noOutline"
                                   style="padding-left: 80px; " placeholder="输入验证码" v-model="dataItem.code"/>
                        </div>
                        <div class="marginL20" style="width: 120px;">
                            <button class="height40 greyRadiusBorder noBg noBorder block borderBoxSize w100p orange"
                                    v-if="!verifyCodeSeconds" @click="getVerifyCode()">获取验证码</button>
                            <button class="height40 greyRadiusBorder noBg noBorder block borderBoxSize w100p orange"
                                    v-else>{{verifyCodeSeconds}}s</button>
                        </div>
                    </div>
                </div>

                <div class="" style="margin-top: 84px;">
                    <button class="okButton block borderBoxSize w100p noBorder font14r" @click="ok()">确定更换</button>
                </div>


            </div>
        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

import userApi from '@/api/user';

// util
import appHelper    from '@/util/appHelper';
import timerManager from "@comp/platformApi/timerManager";

const config = {
    name : 'bingPhone',
    title : '绑定手机',
    description : '',

    apiConfig : {
        get : {
            url : 'portal/v4/user/center/getUserInfo'
        },
    },

    // unit: second
    verifyCodeSendDelay : 60
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            enableDataItem : true,
            autoLoadDataItem : true,
            apiConfig : config.apiConfig,
            dataItem : {
                phone : '',
                code : ''
            },
            verifyCodeSeconds : 0,
            countDownTimer : null
        }
    },
    methods : {
        getVerifyCode() {

            if (!this.dataItem.phone)
            {
                return;
            }

            // check timer
            if (this.countDownTimer)
            {
                appHelper.showHint('验证码' + config.verifyCodeSendDelay + '秒内有效');
                return;
            }

            userApi.sendVerifyCodeAction(this.dataItem.phone, () => {
                appHelper.showHint('发送成功，请查收。');

                this.verifyCodeSeconds = config.verifyCodeSendDelay;
                this.countDownTimer = timerManager.setInterval(() => {
                    this.verifyCodeSeconds--;

                    if (this.verifyCodeSeconds == 0)
                    {
                        timerManager.clearInterval(this.countDownTimer);
                        this.countDownTimer = null;
                    }
                }, 1 * 1000);
            });

        },
        ok() {
            if (this.dataItem == '' || this.validateIdentifyingCode == '')
            {
                appHelper.showHint('请填写完整信息');
                return;
            }

            userApi.bindPhoneAction(this.dataItem, () => {
                appHelper.showHint('绑定成功');
                appHelper.goToPage('myProfile');
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.greyRadiusBorder {
    background: #f4f4f4;
    border: none 0;
    border-radius: 20px;
}
.height40 {
    height: 40px;
    line-height: 40px;
}
.oragne {
    color: #F7AA01;
}
.bgOrange {
    background: #F7AA01;
}
.okButton {
    background: #F7AA01;
    color: white;
    height: 42px;
    line-height: 42px;
    border-radius: 21px;
}
</style>
